import React from 'react'
import {
  BannerDescMobile,
  FloatBannerWrapper,
  ValueForCustomer,
  ValueItem,
  ValueItemDesc, ValueItemDescMobile,
  ValueItemIcon,
} from './FloatBannerStyled'
import { Container } from '../CommonStyled/CommonStyled'
import IMAGES from '../../images'
import config from '../../config'
import DangerouslySetInnerHtml from '../DangerouslySetInnerHtml'
import { buildPath } from '../../utils/common'

const FloatBanner = props => {
  const { data } = props
  return (
    <FloatBannerWrapper minHeight={'240px'}>
      <Container>
        <ValueForCustomer>
          {data?.headerConfig?.introduceInformation && (
            <>
              <ValueItem>
                {data?.headerConfig?.introduceInformation?.image1 && (
                  <ValueItemIcon>
                    <img src={buildPath(data?.headerConfig?.introduceInformation?.image1)} alt={'value'} />
                    <ValueItemDescMobile>
                      <DangerouslySetInnerHtml html={data?.headerConfig?.introduceInformation?.description1} />
                    </ValueItemDescMobile>
                  </ValueItemIcon>
                )}
                <ValueItemDesc>
                  <DangerouslySetInnerHtml html={data?.headerConfig?.introduceInformation?.description1} />
                </ValueItemDesc>
              </ValueItem>
              <ValueItem>
                {data?.headerConfig?.introduceInformation?.image2 && (
                  <ValueItemIcon>
                    <img src={buildPath(data?.headerConfig?.introduceInformation?.image2)} alt={'value'} />
                    <ValueItemDescMobile>
                      <DangerouslySetInnerHtml html={data?.headerConfig?.introduceInformation?.description2} />
                    </ValueItemDescMobile>
                  </ValueItemIcon>
                )}
                <ValueItemDesc>
                  <DangerouslySetInnerHtml html={data?.headerConfig?.introduceInformation?.description2} />
                </ValueItemDesc>
              </ValueItem>
              <ValueItem>
                {data?.headerConfig?.introduceInformation?.image3 && (
                  <ValueItemIcon>
                    <img src={buildPath(data?.headerConfig?.introduceInformation?.image3)} alt={'value'} />
                    <ValueItemDescMobile>
                      <DangerouslySetInnerHtml html={data?.headerConfig?.introduceInformation?.description3} />
                    </ValueItemDescMobile>
                  </ValueItemIcon>
                )}
                <ValueItemDesc>
                  <DangerouslySetInnerHtml html={data?.headerConfig?.introduceInformation?.description3} />
                </ValueItemDesc>
              </ValueItem>
              <ValueItem>
                {data?.headerConfig?.introduceInformation?.image4 && (
                  <ValueItemIcon>
                    <img src={buildPath(data?.headerConfig?.introduceInformation?.image4)} alt={'value'} />
                    <ValueItemDescMobile>
                      <DangerouslySetInnerHtml html={data?.headerConfig?.introduceInformation?.description4} />
                    </ValueItemDescMobile>
                  </ValueItemIcon>
                )}
                <ValueItemDesc>
                  <DangerouslySetInnerHtml html={data?.headerConfig?.introduceInformation?.description4} />
                </ValueItemDesc>
              </ValueItem>
            </>
          )}
        </ValueForCustomer>
      </Container>
    </FloatBannerWrapper>
  )
}

export default FloatBanner
